module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[110]109.12b84e0.woff2";